module.exports = __webpack_public_path__ + "static/media/events_doodle.c0aec01d.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/doodles/events_doodle.png
 ** module id = 643
 ** module chunks = 44
 **/